export default __webpack_public_path__ + "static/media/11.1c34f52f.png";